export interface PassageForm {
  departure_location_id: string;
  arrival_location_id: string;
  date: string;
  hour: string;
  minutes: string;
  observation: string;
  car_id: string;
  [key: string]: any;
}

export interface PassageFormError {
  date: boolean;
  hour: boolean;
  minutes: boolean;
  departure_location_id: boolean;
  arrival_location_id: boolean;
  is_expired: boolean;
  car_id: boolean;
  [key: string]: boolean;
}

export interface Vacancy {
  date: string;
  hour: string;
  minutes: string;
}

export interface VacancyGrouped {
  date: string;
  hour?: string;
  minutes?: string | number;
  items: Array<Vacancy>;
}

export interface VacancyMinuteOption {
  text: string;
  value: string;
}

export interface VacancyGroupedMonth extends VacancyGrouped {
  month: number;
}

export interface PassageState {
  form: PassageForm;
  vacanciesGrouped?: Array<VacancyGrouped>;
  reload?: string;
}

export interface DetailChange {
  value: string | number | undefined | null;
  name: string;
}

export interface EventChange {
  detail: DetailChange;
  target?: any;
}

export interface VacanciesData {
  getVacancies: Array<Vacancy>;
}

export interface VacancyData {
  getVacancy: Array<Vacancy>;
}

/**
 * Agrupamento de disponibilidades de passagens
 * @param vacancies
 * @param handleCheck
 */
export const GroupPassage = (
  vacancies: Array<Vacancy> = [],
  handleCheck = (row: any, vacancy: any) => row.date === vacancy.date,
  handleRow = (vacancy: Vacancy) => ({
    date: vacancy.date,
    items: [vacancy],
  })
) => {
  const vancanciesGroup: Array<VacancyGrouped> = [];

  vacancies.forEach((vacancy: Vacancy) => {
    const vacancyGroup: VacancyGrouped = handleRow(vacancy);
    const verify = vancanciesGroup.find((row: VacancyGrouped) =>
      handleCheck(row, vacancy)
    );
    if (verify === undefined) {
      return vancanciesGroup.push(vacancyGroup);
    }
    if (verify !== null && verify !== undefined) {
      return verify.items.push(vacancy);
    }
  });

  return vancanciesGroup;
};
